import { render, staticRenderFns } from "./ouItemMMO.vue?vue&type=template&id=418d3e54&lang=pug&"
import script from "./ouItemMMO.vue?vue&type=script&lang=js&"
export * from "./ouItemMMO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports